// Chat-rail design tokens (Style E, light-primary; dark mirror).
// Ported from _temp/claude_design_agent_chat_handoff_v1/chat-rail-design/tokens.jsx
// (resolved 2026-04-26). Bounds reconciled with spec §3.2 P8: rail_w_min = 380
// (Designer's tokens.jsx had 360).

export type ChatRailTokens = typeof T_LIGHT | typeof T_DARK;

const baseShared = {
  sans: "'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  mono: "'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace",

  fs_micro: 10,
  fs_meta: 11,
  fs_label: 12,
  fs_body: 13,
  fs_title: 14,
  fs_h: 15,

  ease_out: "cubic-bezier(0.22, 0.61, 0.36, 1)",
  ease_in_out: "cubic-bezier(0.65, 0, 0.35, 1)",
  ease_emph: "cubic-bezier(0.32, 0.72, 0, 1)",
  d_micro: 120,
  d_short: 180,
  d_med: 240,
  d_long: 320,

  s1: 4,
  s2: 8,
  s3: 12,
  s4: 16,
  s5: 20,
  s6: 24,
  s7: 32,

  r_xs: 3,
  r_sm: 5,
  r_md: 8,
  r_lg: 10,
  r_pill: 999,

  rail_w_default: 480,
  rail_w_min: 380,
  rail_w_max: 720,
  tab_strip_w: 48,
  tab_size: 40,
  drag_handle_w: 4,
  conversation_tab_visible_budget: 3,
  conversation_tab_height: 40,
} as const;

export const T_LIGHT = {
  ...baseShared,
  bg: "#FAFAFB",
  rail: "#FFFFFF",
  panel: "#F6F7F9",
  panel2: "#F0F2F5",
  panel3: "#E6E9EE",
  hair: "#EAECEF",
  hair2: "#DEE1E6",
  divider: "#F0F2F5",
  text: "#0F1115",
  textDim: "#5C6370",
  textMute: "#8A8F99",
  textFaint: "#B6BAC2",
  accent: "#5A5BD9",
  accentSoft: "#EEEEFB",
  accentDim: "#A6A7E5",
  accentBorder: "#C8CAF1",
  confirm: "#1F6A4F",
  confirmSoft: "#E5EDE8",
  confirmBorder: "#BFD2C7",
  unread: "#3B82F6",
  pending: "#D97706",
  pendingSoft: "#FEF3E0",
  failed: "#DC2626",
  running: "#3B82F6",
  success: "#16A34A",
} as const;

export const T_DARK = {
  ...baseShared,
  bg: "#0B0C0F",
  rail: "#101216",
  panel: "#16181D",
  panel2: "#1C1F25",
  panel3: "#262A32",
  hair: "#23262D",
  hair2: "#2E323A",
  divider: "#1A1D22",
  text: "#E6E8EC",
  textDim: "#9AA0AB",
  textMute: "#6B7280",
  textFaint: "#4A4F58",
  accent: "#7C7CF5",
  accentSoft: "#1E1E3A",
  accentDim: "#3A3A6E",
  accentBorder: "#3A3A6E",
  confirm: "#5BB58A",
  confirmSoft: "#163024",
  confirmBorder: "#2C5A44",
  unread: "#60A5FA",
  pending: "#F59E0B",
  pendingSoft: "#3A2A0E",
  failed: "#F87171",
  running: "#60A5FA",
  success: "#34D399",
} as const;

export function chatRailTokens(mode: "light" | "dark"): ChatRailTokens {
  return mode === "dark" ? T_DARK : T_LIGHT;
}
